import {NgModule} from "@angular/core";
import {
  DefaultLayoutComponent,
  FileManagerControllerComponent,
  FileManagerDialogControllerComponent,
  FileManagerDialogFormComponent,
  LanguageSwitcherComponent,
  LoadingIndicatorComponent,
  NavbarComponent,
  NavbarControllerComponent,
  PanelComponent,
  SearchbarComponent,
  SearchbarControllerComponent
} from "./components";
import {MaterialModule} from "../material.module";
import {CommonModule} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {RouterModule} from "@angular/router";
import {NotificationPanelComponent} from './components/notification-panel/notification-panel.component';
import {AuthImagePipe} from "./pipes";
import {FilterFiuPipe} from "./pipes/filter-user-fiu.pipe";
import { SidePanelComponent } from './components/side-panel/side-panel.component';
import { SupportControllerComponent } from './components/support/support-controller/support-controller.component';
import { SupportComponent } from './components/support/support-component/support.component';
import {UserNotFoundComponent} from "./components/user-not-found/user-not-found-component/user-not-found.component";
import { UserNotFoundControllerComponent } from './components/user-not-found/user-not-found-controller/user-not-found-controller.component';
import {AccessRestrictedComponent} from './components/access-restricted/access-restricted.component';

@NgModule({
  declarations: [
    LanguageSwitcherComponent,
    FileManagerControllerComponent,
    LoadingIndicatorComponent,
    FileManagerDialogControllerComponent,
    FileManagerDialogFormComponent,
    DefaultLayoutComponent,
    NavbarComponent,
    PanelComponent,
    SearchbarComponent,
    NotificationPanelComponent,
    NavbarControllerComponent,
    AuthImagePipe,
    FilterFiuPipe,
    SidePanelComponent,
    SearchbarControllerComponent,
    SupportControllerComponent,
    SupportComponent,
    SearchbarControllerComponent,
    UserNotFoundComponent,
    UserNotFoundControllerComponent,
    AccessRestrictedComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
  ],
  exports: [
    LanguageSwitcherComponent,
    FileManagerControllerComponent,
    LoadingIndicatorComponent,
    DefaultLayoutComponent,
    NavbarComponent,
    PanelComponent,
    SearchbarComponent,
    NavbarControllerComponent,
    AuthImagePipe,
    FilterFiuPipe,
    SidePanelComponent,
    SearchbarControllerComponent,
    SupportControllerComponent,
  ],
})

export class SharedModule {
}
